import { useState, useEffect } from "react";
import { MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";
import TripQuizDialog from "@/components/TripQuiz/TripQuizDialog";
import { cn } from "@/lib/utils";

const FloatingTripQuiz = () => {
  const { i18n } = useTranslation();
  const [quizOpen, setQuizOpen] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const isGreek = i18n.language === "el";

  // Briefly show tooltip to draw attention
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowTooltip(true);
      const hideTimer = setTimeout(() => {
        setShowTooltip(false);
      }, 4000);
      return () => clearTimeout(hideTimer);
    }, 2500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <div className="fixed bottom-[92px] md:bottom-[104px] right-5 md:right-8 z-[50] flex items-center gap-3">
        <div
          className={cn(
            "bg-white text-ocean-deep border border-ocean-deep/10 px-4 py-2 rounded-2xl text-xs font-semibold font-body shadow-[0_10px_30px_-10px_rgba(15,40,70,0.25)] transition-all duration-300 pointer-events-none whitespace-nowrap",
            showTooltip
              ? "opacity-100 translate-x-0 scale-100"
              : "opacity-0 translate-x-4 scale-95 pointer-events-none"
          )}
        >
          <div className="relative">
            {isGreek ? "Δωρεάν πλάνο διακοπών 🧭" : "Free custom trip plan 🧭"}
            <div className="absolute top-1/2 -right-5 -translate-y-1/2 border-8 border-transparent border-l-white drop-shadow-[1px_0_0_rgba(15,40,70,0.05)]" />
          </div>
        </div>

        <button
          onClick={() => setQuizOpen(true)}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          aria-label="Trip Planner Quiz"
          className="group relative flex h-14 w-14 items-center justify-center rounded-full bg-ocean-deep text-white shadow-[0_8px_25px_rgba(15,40,70,0.4)] transition-all duration-300 hover:scale-110 hover:-translate-y-1 hover:shadow-[0_12px_30px_rgba(15,40,70,0.6)]"
        >
          <MapPin className="relative z-10 h-6 w-6 transition-transform duration-300 group-hover:scale-110" />
        </button>
      </div>

      <TripQuizDialog open={quizOpen} onOpenChange={setQuizOpen} />
    </>
  );
};

export default FloatingTripQuiz;
